module.exports = __webpack_public_path__ + "static/guarantee-certificate-e6e4ac1d0784841745a725111cccb5a6.png";